<template>
  <v-app>
    <v-app-bar
      v-if="getLogeado == true"
      app
      color="white"
      class="elevation-0"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <div class="d-flex align-center"  @click.stop="drawer = !drawer" >
        <span class="font-weight-bold mt-1 hidden-sm-and-down textgrey--text" >
          Administrador del cotizador
        </span>
      </div>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn text @click="modalCostoEnvio = true"> <v-icon >mdi-cube-send</v-icon> </v-btn>
      </v-toolbar-items>

      <v-badge
        bordered
        color="primary"
        icon="mdi-lock"
        overlap
        class="mr-6"
      >
        <v-icon>mdi-shopping-outline</v-icon>
      </v-badge>

      <v-badge
        bordered
        color="error"
        icon="mdi-lock"
        overlap
        class="mr-6"
      >
        <v-icon>mdi-bell-ring-outline</v-icon>
      </v-badge>

      <v-badge
        avatar
        bordered
        overlap
      >
        <template v-slot:badge>
          <v-avatar>
            <v-img src="https://cdn.vuetifyjs.com/images/logos/v.png"></v-img>
          </v-avatar>
        </template>

        <v-avatar size="40">
          <v-img src="https://cdn.vuetifyjs.com/images/john.png"></v-img>
        </v-avatar>
      </v-badge>
     

      <v-btn color="white" icon @click="cerrarSesion()"><v-icon>mdi-exit-to-app</v-icon></v-btn>
 
    </v-app-bar>

    <v-navigation-drawer
      v-if="getLogeado == true"
      v-model="drawer"
      app
      class="elevation-0"
    >
      <!-- <v-container>
        <img src="@/assets/logo.png" alt="alt" max-height="80" width="200" align="center">
      </v-container>
      <v-card-text class="primary pa-1 white--text" align="center">
        {{ getdatosUsuario.nomuser }}
      </v-card-text> -->

      <v-list dense nav class="py-0">
        <v-list-item two-line  >
          <v-list-item-avatar size="40px" avatar>
            <img src="@/assets/mascota.png" alt="alt" max-height="80" width="200" align="center">
            <!-- <avataaars></avataaars> -->
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>  {{ getdatosUsuario.nomuser }} </v-list-item-title>
            <v-list-item-title>  Maquinador </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </v-list>
      
      <v-list nav dense class="mr-0" >
        <template>
          <v-list-item 
            :to="{name: 'home'}" 
            active-class="claseFondo"
          >
            <v-list-item-content >
              <v-list-item-title style="font-family: 'Poppins', sans-serif !important;">
                Inicio
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon>home</v-icon>
            </v-list-item-action>
          </v-list-item>
        </template>

        <template >
          <v-list-item 
            :to="{name: 'pedidos'}" 
            link
            active-class="claseFondo"
          >
            <v-list-item-content >
              <v-list-item-title style="font-family: 'Poppins', sans-serif !important;">
                Cotizaciones
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon>shopping_basket</v-icon>
            </v-list-item-action>
          </v-list-item>
        </template>

        <template >
          <v-list-item 
            :to="{name: 'cotizar'}" 
            link
            active-class="claseFondo"
          >
            <v-list-item-content >
              <v-list-item-title style="font-family: 'Poppins', sans-serif !important;">
                Cotizar
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon>shopping_basket</v-icon>
            </v-list-item-action>
          </v-list-item>
        </template>

        <!-- <template >
          <v-list-item 
            :to="{name: 'maquilaciones'}"
            active-class="claseFondo"
          >
            <v-list-item-content >
              <v-list-item-title style="font-family: 'Poppins', sans-serif !important;">
                Maquilaciones
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon>mdi-gift-open-outline</v-icon>
            </v-list-item-action>
          </v-list-item>
        </template>  -->
        
        <template v-for="item in items" class="priclaseFondomary">
          <v-layout
            v-if="item.heading"
            :key="item.heading"
            align-center
          >
          </v-layout>

          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            append-icon="item.icon"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
          >
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.path"
            >
              <v-list-item-content >
                <v-list-item-title style="font-family: 'Poppins', sans-serif !important; font-size: 14px;" class="grey--text">
                  <b>{{ child.text }}</b>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
            </v-list-item>
            
            <template v-slot:activator>
              <v-list-item >
                <v-list-item-content>
                  <v-list-item-title style="font-family: 'Poppins', sans-serif !important; font-size: 14px;" class="grey--text"> 
                  <b> {{ item.text}}</b>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>

    <!-- Ruteo de vistas -->
    <v-main >
      <v-slide-y-transition mode="out-in">
       <router-view/>
      </v-slide-y-transition>
    </v-main>

    <!-- CERRAR SESION -->
    <v-dialog v-model="cerrarSesionModal" max-width="400px">
      <v-card >
          <v-card-text class="text-subtitle-1 pa-6" style="display: table-cell; vertical-align: middle;">
            <strong>¿ Estás seguro que deseas cerrar la sesión ?</strong> 
          </v-card-text>

          <v-footer >
            <v-spacer></v-spacer>
              <v-btn color="error"   class="mr-2" @click="cerrarSesionModal = false">No, cancelar</v-btn>
              <v-btn color="primary"  text  class="elevation-6"  @click="salirDePlataforma()">Si, cerrar sesión</v-btn>
            </v-footer>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog v-model="modalCostoEnvio" width="400">
      <v-card class="pa-4">
        <costoEnvio
          @modal="modalCostoEnvio = $event;"
        />
      </v-card>
    </v-dialog>

    <v-overlay v-if="blockear">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

  </v-app>
</template>

<script>
  import store from '@/store'
  import {mapGetters, mapActions} from 'vuex'
  import costoEnvio from '@/views/administrativo/envios/costo_envio.vue'

  export default {
    components: {
			costoEnvio,
		},
    props: {
      source: String,
    },
    data: () => ({
      logo:'',
      snackbar: false,
      drawer: null,
      cerrarSesionModal: false,
      blockear: false,
      modalCostoEnvio: false,
      items: [
        // {
        //   icon: 'mdi-bike-fast', 'icon-alt': 'keyboard_arrow_down', text: 'Repartidores',
        //   model: false,
        //   children: [
        //     { text: 'Pendientes'  ,path: 'pedidos_pendientes' , icon:'mdi-human-dolly'},
        //     // { text: 'Entregados'  ,path: 'pedidos_entregados' , icon:'mdi-account-heart-outline'},
        //   ],
        // },
        {
          icon: 'chrome_reader_mode', 'icon-alt': 'keyboard_arrow_down', text: 'Clasificar Productos',
          model: false,
          children: [
            { text: 'Catálogo de articulos'  ,path: 'catproductos' ,      icon:'chrome_reader_mode'},
            { text: 'Familias'               ,path: 'familias',           icon:'bookmarks'},
            { text: 'Categorías'             ,path: 'catlab',             icon:'bookmarks'},
            { text: 'Subcategoria'           ,path: 'subcatego',          icon:'bookmarks'},
            // { text: 'Efectos'                ,path: 'efectos',            icon:'bookmarks'},
            // { text: 'Tipos'                  ,path: 'tipos',              icon:'bookmarks'},
            // { text: 'Aromas'                 ,path: 'aromas',             icon:'bookmarks'},
            // { text: 'Sabores'                ,path: 'sabores',            icon:'bookmarks'},
          ],
        },
        {
          icon: 'inbox', 'icon-alt': 'keyboard_arrow_down', text: 'Almácen',
          model: false,
          children: [
            // { text: 'Catálogo de articulos'  ,path: 'catproductosalm' ,   icon:'chrome_reader_mode'},
            // { text: 'Laboratorios'           ,path: 'catlab',             icon:'local_hospital'},
            { text: 'Entradas  '                ,path: 'catentradas'  ,      icon:'book'},
            { text: 'Salidas'                   ,path: 'catsalidas',         icon:'bookmarks'},
            { text: 'Existencias'               ,path: 'catexistencia' ,     icon:'store'},
            // { text: 'Discrepancias'          ,path: 'catdiscre',          icon:'assignment'},
          ],
        },
        {
          icon: 'calendar_view_day', 'icon-alt': 'keyboard_arrow_down', text: 'Configuración',
          model: false,
          children: [
            { text: 'Usuarios'     ,path: 'catusuarios',   icon:'group'},
            // { text: 'Clientes'     ,path: 'catclientes',   icon:'group'},
            // { text: 'Configurar'   ,path: 'Configurar',    icon:'settings'},
            // { text: 'Pagos     '   ,path: 'catpagos',      icon:'settings'},
          ], 
        },

        {
          icon: 'style', 'icon-alt': 'keyboard_arrow_down', text: 'Marketing',
          model: false,
          children: [
            { text: 'Banners'     ,path: 'banners',     icon:'photo_library'},
            { text: 'Novedades'   ,path: 'novedades',   icon:'loyalty'},
            // { text: 'Envío de promociones'   ,path: 'promos',   icon:'email'},
          ], 
        },

        // {
        //   icon: 'style', 'icon-alt': 'keyboard_arrow_down', text: 'Administración',
        //   model: false,
        //   children: [
        //     { text: 'Tipo de Elementos'   ,path: 'TipoElementos'   ,   icon:'photo_library'},
        //     { text: 'Elementos'           ,path: 'Elementos'       ,   icon:'loyalty'},
        //     { text: 'Proveedores'         ,path: 'Proveedores'     ,   icon:'loyalty'},
        //     { text: 'Requisiciones'       ,path: 'Requisiciones'   ,   icon:'loyalty'},
        //     { text: 'Mis Requisiciones'   ,path: 'MisRequisiciones',   icon:'loyalty'},
        //     { text: 'Egresos'             ,path: 'Egresos'         ,   icon:'loyalty'},
        //   ], 
        // },
        
       
      
      ],
    }),

    created(){
      // this.traerTema(1)
      // this.$http.get('config.list').then(response=>{
      //   this.ciaws = response.body
      //   this.logo = this.$http.options.root + 'fotos/' + this.ciaws.logourl
      //   // this.color()
      // }, error => {
      //   console.log(error)
      // })
    },

    methods:{
      // ...mapActions('tema',['traerTema']),
      ...mapActions('Login', ['salirLogin']),
      // color(){
      //   this.$vuetify.theme.themes.light.primary = this.ciaws.primario
      //   this.$vuetify.theme.themes.light.secondary = this.ciaws.secundario
      //   this.$vuetify.theme.themes.light.success = this.ciaws.correcto
      //   this.$vuetify.theme.themes.light.info = this.ciaws.informatico
      //   this.$vuetify.theme.themes.light.error = this.ciaws.errores
      //   this.$vuetify.theme.themes.light.warning = this.ciaws.peligro
      // },

      cerrarSesion(){
        this.cerrarSesionModal = true;
      },

      salirDePlataforma(){
        this.blockear = true;
        this.cerrarSesionModal = false;

        setTimeout(() => { 
          this.salirLogin()
          location.reload();
          this.blockear = true;
          // this.$store.dispatch("salir");
          this.$router.push({ name: 'Login'});
        }, 1000);
      },
      // salir(){
      //   this.salirLogin()
      //   location.reload();
      //   // Mando a llamar la accion salir
      //   this.$store.dispatch("salir")
      // },

    },

    computed:{
     ...mapGetters('Login', ['getdatosUsuario', 'getLogeado']),
    //  ...mapGetters('tema', ['getTema']),
    
      logueado(){
        return this.$store.state.usuario;
      },
    }
}
</script>

<style >

  .claseFondo {
    background-color: #f4d300; /* Color personalizado (ej: azul claro) */
    color: white !important; /* Color del texto (opcional) */
  }

  .btnSuccess{
    background-color: #f4d300; /* Color personalizado (ej: azul claro) */
    color: white !important; /* Color del texto (opcional) */
  }

  body {
    font-family: 'Poppins', sans-serif !important;
  }

  ::-webkit-scrollbar {
    width: 5px;
    height : 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: rgb(255, 255, 255);
    /* background: transparent; */
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: pink;
  }

  #grupos td:nth-child(1) {
    background-color: #E8E8E8 !important;
  }

  #grupos td{
    font-size: 12px !important;
    /* padding-left: 10px;
    padding-right: 10px; */
  }

  main{
    background: white ;
    font-family: 'Poppins', sans-serif !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-navigation-drawer__content::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-button:increment,.v-navigation-drawer__content::-webkit-scrollbar-button{
    display: none;
  }

  .v-navigation-drawer__content::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  html{
    background: white;
    font-family: 'Poppins', sans-serif !important;
  }

  .v-main__wrap{
    background: white !important;
    font-family: 'Poppins', sans-serif !important;
  }

  .v-application--is-ltr .v-list-item__icon:first-child{
    margin-right: 8px !important;
    font-family: 'Poppins', sans-serif !important;
  }

  .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 6px !important;
    font-family: 'Poppins', sans-serif !important;
  }


  .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
    align-self: center;
    margin: 0;
    min-width: 0px !important;
    justify-content: flex-end;
    font-family: 'Poppins', sans-serif !important;
  }

  .shadowCard{
    border-radius: 8px !important; 
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.02)  !important;
  }

  .v-application--is-ltr .v-list--dense.v-list--nav .v-list-group--no-action > .v-list-group__items > .v-list-item {
    padding-left: 10px !important;
    font-family: 'Poppins', sans-serif !important;
  }
</style>



